<template>
  <div class="container">
    <h1 class="title">Promotions</h1>
    <h2 class="subtitle">
      Übersicht über alle Promotions
    </h2>
    <b-table
      :data="promotions"
      paginated
      backend-pagination
      @page-change="onPageChange"
      :total="total"
      :per-page="pageSize"
      striped
    >
      <template slot-scope="props">
        <b-table-column field="type" label="Art">{{
          props.row.type
        }}</b-table-column>
        <b-table-column field="offerTemplateId" label="Angebot">
          <OfferIdTooltip :id="props.row.offerTemplateId" />
        </b-table-column>
        <b-table-column field="from" label="Von">{{
          props.row.from | formatDate
        }}</b-table-column>
        <b-table-column field="to" label="Bis">{{
          props.row.to | formatDate
        }}</b-table-column>
        <b-table-column field="variantPromotions" label="Reduktionen">
          <div class="tags">
            <b-tag
              v-for="variant in props.row.variantPromotions"
              :key="variant.variantId"
              size="is-medium"
            >
              {{ variant.currency }} {{ variant.totalPrice }}
            </b-tag>
          </div>
        </b-table-column>
      </template>
    </b-table>
  </div>
</template>
<script>
import offerApi from '@/api/offers-api'
import OfferIdTooltip from '@/components/OfferIdTooltip'
export default {
  name: 'Promotions',
  components: {OfferIdTooltip},
  data() {
    return {
      promotions: [],
      page: 1,
      pageSize: 16,
      total: 0,
    }
  },
  async mounted() {
    await this.refreshData()
  },
  methods: {
    async refreshData() {
      const result = await offerApi.getAllPromotions(
        this.page,
        this.pageSize,
        'from desc',
      )
      this.promotions = result.results
      this.page = result.page
      this.pageSize = result.pageSize
      this.total = result.total
    },
    async onPageChange(p) {
      this.page = p
      await this.refreshData()
    },
  },
}
</script>
